/** @jsxRuntime classic */
/** @jsx isolateComponent */

import { css } from '@emotion/react';
import {
  ColorName,
  Colors,
  Heading,
  HeadingLevel,
  Typography,
} from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';

import { COLOR_KEYS, MEDIA_MAX_WIDTH } from '../../../constants';
import { Accordion, Item } from './Accordion';

type Props = {
  /**
   * Determines whether two drawers can be open at the same time or if opening one automatically closes any other open drawer.
   */
  autoClose: boolean;
  backgroundColor?:
    | typeof COLOR_KEYS.blue10
    | typeof COLOR_KEYS.cream
    | typeof COLOR_KEYS.neutral100
    | typeof COLOR_KEYS.neutral200;
  title: string;
  items: Array<Item>;
};

const Styles = labelStyles('FAQSection', {
  root: (backgroundColor: ColorName) =>
    css({
      padding: '67px 0px',
      backgroundColor: Colors[backgroundColor],
      [MEDIA_MAX_WIDTH.medium]: {
        padding: '60px 50px',
      },
      [MEDIA_MAX_WIDTH.small]: {
        padding: '55px 19px',
      },
    }),
  title: css({
    ...Typography.pageHeader3,
    color: Colors.earth,
    marginBottom: '60px',
    textAlign: 'center',
  }),
});

export function FAQSection({
  autoClose = true,
  backgroundColor = COLOR_KEYS.neutral100,
  title = 'FAQ',
  items = [],
}: Props) {
  return (
    <div css={Styles.root(backgroundColor)}>
      <HeadingLevel>
        <Heading css={Styles.title}>{title}</Heading>
      </HeadingLevel>
      <Accordion autoClose={autoClose} items={items} />
    </div>
  );
}
